import Vue from "vue";
import Vuetify from "vuetify/lib";
import fa from "vuetify/es5/locale/fa";
import "@mdi/font/css/materialdesignicons.min.css";

Vue.use(Vuetify);

export default new Vuetify({
  rtl: true,
  lang: {
    locales: { fa },
    current: "fa",
  },
  icons: {
    iconfont: "mdiSvg", // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  },
  theme: {
    themes: {
      light: {
        primary: "#E75113",
        secondary: "#10BDAA",
        accent: "#1068BD",
        error: "#DC1325",
        info: "#B7D812",
        success: "#33C310",
        warning: "#E7DC14",
      },
    },
  },
});
